exports.company = "thum";
